import React, {FC, Fragment} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../../../../libs/shared/ui/src/components/utility/skeleton';
import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {StyledFlex} from '../../../reportViewer/reportCommons';
import {ChartSerie} from '../../commons/types';
import {ChartLegendBadge} from './chartLegendBadge';

/*
 * Props.
 */

export interface ChartLegendProps<T> {
  series: ReadonlyArray<ChartSerie<T>>;
  isLoading?: boolean;
}

/*
 * Style.
 */

const StyledSerieLabelSpan = styled.span`
  color: ${(p) => p.theme.greys.shade70};
  margin-right: 20px;
  font-size: ${fontSizes.verySmall};
`;

const StyledSkeleton = styled(Skeleton)`
  margin-right: 20px;
`;

/*
 * Component.
 */

export const ChartLegend = <T,>({series, isLoading}: ChartLegendProps<T>): ReturnType<FC> => (
  <StyledFlex>
    {series.map((serie, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Fragment key={index}>
        {isLoading ? (
          <StyledSkeleton height="13px" width="150px" />
        ) : (
          <StyledFlex>
            <ChartLegendBadge color={serie.color} />
            <StyledSerieLabelSpan>{serie.label}</StyledSerieLabelSpan>
          </StyledFlex>
        )}
      </Fragment>
    ))}
  </StyledFlex>
);
